"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "accumoli": {
    "d63d33ce": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "casaventre": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50228c29": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "cassino": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "716617bc": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "colleposta": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "30e3e7ec": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "collespada": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "daa87dc8": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "fonte-del-campo": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "03d1cea6": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "grisciano": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "690d3db6": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "illica": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "899aaf09": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "libertino": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "762aa504": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "macchia": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3411e12": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-casoli": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65b71894": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-d-api": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c985fc3d": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "roccasalli": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33a299fa": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "435781f5": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "terracino": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4ba2ee87": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "tino": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dbbfb629": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "skipSearch": false
    }],
    "villanova": [{
      "hkey": "eaef9217",
      "slug": "accumoli",
      "name": "Accumoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;